import { gql } from "@apollo/client";
import { CORE_PROFILE_FIELDS } from "graphql/fragments";

const EVENT_NODE_FIELDS = gql`
  ${CORE_PROFILE_FIELDS}
  fragment EventNodeFields on Event {
    createdAt
    uuid
    key
    payload
    eventType
    type
    impersonator {
      id
      firstName
      lastName
      name
    }
    user {
      id
      profile {
        ...ProfileFields
      }
      firstName
      lastName
      name
    }
  }
`;

// Shared pagination fields used by event queries
const EVENT_PAGINATION_FIELDS = gql`
  fragment EventPaginationFields on EventConnection {
    totalCount
    currentPage
    perPage
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    edges {
      cursor
      node {
        id
      }
    }
  }
`;

const metadataFields = `
  value
  count
  formattedValue
`;

const EVENT_RESULT_FILTER_METADATA = gql`
  fragment TimelineEventsResultFilterMetadata on TimelineEventsResultFilterMetadata {
    eventType {
      ${metadataFields}
    }
    eventTargetType {
      ${metadataFields}
    }
    key {
      ${metadataFields}
    }
  }
`;

export { EVENT_NODE_FIELDS, EVENT_PAGINATION_FIELDS, EVENT_RESULT_FILTER_METADATA };
